export const suppliersBulkConfig = {
  tableName: 'suppliers',
  requiredFields: ['name'],
  fieldMappings: {
    name: {
      type: 'string',
      required: true,
      maxLength: 100,
      label: 'Supplier Name'
    },
    country: {
      type: 'string',
      required: false,
      maxLength: 50,
      label: 'Country'
    },
    contact_email: {
      type: 'string',
      required: false,
      pattern: /^.+@.+\..+$/,
      label: 'Contact Email'
    },
    phone: {
      type: 'string',
      required: false,
      maxLength: 20,
      label: 'Phone Number'
    },
    description: {
      type: 'string',
      required: false,
      maxLength: 500,
      label: 'Description'
    },
    rating_overall: {
      type: 'number',
      required: false,
      min: 0,
      max: 5,
      default: 0,
      label: 'Overall Rating'
    },
    rating_service: {
      type: 'number',
      required: false,
      min: 0,
      max: 5,
      default: 0,
      label: 'Service Rating'
    },
    rating_punctuality: {
      type: 'number',
      required: false,
      min: 0,
      max: 5,
      default: 0,
      label: 'Punctuality Rating'
    },
    rating_quality: {
      type: 'number',
      required: false,
      min: 0,
      max: 5,
      default: 0,
      label: 'Quality Rating'
    },
    is_favorite: {
      type: 'boolean',
      required: false,
      default: false,
      label: 'Is Favorite'
    }
  },
  validateItem: (item) => {
    const errors = [];
    
    // Check required fields
    suppliersBulkConfig.requiredFields.forEach(field => {
      if (!item[field]) {
        errors.push(`${field} is required`);
      }
    });

    // Validate email format
    if (item.contact_email && !suppliersBulkConfig.fieldMappings.contact_email.pattern.test(item.contact_email)) {
      errors.push('Invalid email format');
    }

    // Validate ratings
    ['rating_overall', 'rating_service', 'rating_punctuality', 'rating_quality'].forEach(rating => {
      if (item[rating] !== undefined) {
        const value = Number(item[rating]);
        if (isNaN(value) || value < 0 || value > 5) {
          errors.push(`${rating} must be a number between 0 and 5`);
        }
      }
    });

    return {
      isValid: errors.length === 0,
      errors
    };
  }
}; 